
import visitorInfoWidgetTemplate from '../templates/visitor_info/visitor_info.ejs';

import ADACompliant from '../core/hooks/ADACompliant';
import addStyleText from '../core/hooks/addStyleText';
import addStyleTextInIframe from '../core/hooks/addStyleTextInIframe';
import CompanyLevelBlockValidator from '../core/hooks/CompanyLevelBlockValidator';
import parseTemplate from '../core/hooks/parseTemplate';
import SetADACompliantAttributes from '../core/hooks/SetADACompliantAttributes';
import throttleByFunctionName from '../core/hooks/throttleByFunctionName';
import { BaseWidget } from '../core/BaseWidget';
import WidgetTypes from '../core/enums/WidgetTypes';
import GlobalVariables from '../core/GlobalVariables';
import PhoneCountryData from '../core/validators/PhoneContryData';
import PhoneValidator from '../core/validators/PhoneValidator';
import WidgetView from '../core/WidgetView';
import googleAnalyticsObjectInit from '../core/hooks/googleAnalyticsObjectInit';
import getGaClientId from '../core/hooks/getGaClientId';
import GetChatID from '../core/hooks/GetChatID';
import matchPhone from '../core/hooks/matchPhone';
import loadJQuery from '../core/hooks/loadJQuery';
import Cookies from '../core/hooks/Cookies';
import WidgetStates from '../core/hooks/WidgetStates';
import getCookieValue from '../core/hooks/getCookieValue';
import ChatMode from '../core/hooks/ChatMode';

// TODO: THIS FUNCTIONALITY SHOULD BE DEV TESTED
export default class WebSmsFormInvitation extends BaseWidget {
    constructor(options) {
        super(Object.assign(options, { widget: WidgetTypes.WebSmsForm }));
        this.ready();
    }

    ready() {
        const me = this;

        const reactToSmsClick = (data) => {
            me.initiatedBy = data.chatInitiatedBy;
            if ((me.options.preChat || me.options.standardInvitationEnabled) && me.options.hasSmsNumber) {
                me.options.startChat = function () {
                    var origin = WidgetTypes.Tab;
                    if (me.options.videoGreet) {
                        me.$('#apexchat_invitation_container_wrapper', me.DOM).addClass('greet_video_invitation_container_start_chat');
                        var videoGreetInvitationWidget = me.$('#apexchat_video_greet_invitation_wrapper');
                        if (videoGreetInvitationWidget && videoGreetInvitationWidget.length > 0 && videoGreetInvitationWidget[0].style.display == 'block') {
                            origin = WidgetTypes.VideoGreetInvitation;
                        }
                    }

                    me.state.changeState({ toState: WidgetStates.Clicked, value: { initiatedBy: data.chatInitiatedB }, origin: origin });
                    if (me.isWindowedStarted() || me.options.chatMode == ChatMode.Windowed) {
                        me.options.chatInitiatedBy = data.chatInitiatedBy;
                        me.startWindowedChat(Object.assign(me.options, { shouldContinueMapping: ApexChat.shouldContinueMapping, FullTextVisitorResponse: ApexChat.FullTextVisitorResponse })); //pass parameter as a querystring
                    }
                };
                ApexChat.localStorageAPI.Store('sms_bottomsheet_opened_forcefully', true);
                me.options.startChat();
            }
            else {
                if (me.view) {
                    me.view.unrender(WidgetStates.ShownMaximized, true);
                }
                loadJQuery().then(_ => {
                    this.$ = ApexChat.ApexChatJquery;
                    me.create();
                })
            }

        };
        super.ready();

        this.subscribe('apexchat_sms_form_show', reactToSmsClick);
        // ADA Compliance
        // summary: CSS Class 'apexchat_ada_compliance' has no CSS Styling behind it means it won't effect on UI.
        // Its only for detecting the ADA Complianced HTML elements on which we do need to have the TAB Focus.
        // This is the Utility function which takes all HTML elements having the class 'apexchat_ada_compliance' as ARRAY, and apply the TabIndex on all of them.

        ADACompliant.push(me.DOM.getElementsByClassName('.apexchat_ada_compliance')).apply();
        // ADA compliance add attribute in start chat button
        SetADACompliantAttributes(
            me.DOM,
            this.options.chatMode,
            'apexchat_ada_compliance_start_chat'
        );
    }

    create() {
        super.create();
        const me = this;
        me.options.disclaimer = '';
        me.options.visitorTitle = parseTemplate(me.options.visitorTitle, me.options);
        const html = visitorInfoWidgetTemplate(me.options);
        const form = `<form id='apexchat_visitorInfo_container_wrapper'>${html}</form>`;
        me.options.hide = me.hide.bind2(me);
        me.options.chatInitiatedBy = me.chatInitiatedBy;
        me.options.$ = me.$;
        me.options.context = me.DOM;
        const WebSmsFormValidator = function (options) {
            const init = function () {
                const me = this;
                me.options = options;
                me.$ = me.options.$;
                me.context = me.options.context;
                me.elements = {
                    formContainerSelector: '#apexchat_visitorInfo_container_wrapper',
                    phoneContainerSelector: '#apexchat_visitorInfo_container_wrapper  .phone', // may or may not exist, defaults to the message container if not found
                    phoneWarningSelector: '#apexchat_visitorInfo_container_wrapper  .phone  span',
                    phoneSelector: 'input[name=phone]',
                    submitBtnSelector: '.submit-button',
                    confirmationMessageSelector: '#apexchat_msg_sent',
                    formVisitorSelector: '#apexchat_form_visitor',
                    cancelBtnSelector: '.visitorinfo_close'
                };
                me.messages = {
                    SENT: 'Thank You!',
                    FAILED: 'Request submission failed',
                    PLACEHOLDER_PHONE: 'Enter your mobile number'
                };
                me.styles = {
                    SUBMIT_ENABLED: 'apexchat_enabled_submit',
                    WARNING_ENABLED: 'apexchat_already_exist',
                    ERROR_ENABLED: 'apexchat_error'
                };
                me.cookieTime = 60 * 60 * 3;
            };
            const reset = function () {
                const me = this;
                me.formSubmit = false;
                me.context.querySelector(me.elements.phoneContainerSelector)?.classList.remove(
                    me.styles.WARNING_ENABLED
                );
                me.context.querySelector(me.elements.phoneWarningSelector)?.style.display = 'none';
                me.context.querySelector(me.elements.phoneSelector).value = '';
                me.context.querySelector(me.elements.submitBtnSelector, me.context)?.disabled = true;
                const confirmationMessage = document.querySelector(me.elements.confirmationMessageSelector);
                if (confirmationMessage && confirmationMessage.parentNode) {
                    confirmationMessage.parentNode.removeChild(confirmationMessage);
                }
                me.context.querySelector(me.elements.submitBtnSelector, me.context).classList.remove(
                    me.styles.SUBMIT_ENABLED
                );
            };
            const initialDisplay = function () {
                const me = this;
                const container = me.$(me.elements.formContainerSelector, me.context);
                if (container.length) {
                    me.reset();
                    me.show();
                } else {
                    me.options.disclaimer = '';
                    me.options.visitorTitle = parseTemplate(me.options.visitorTitle, me.options);
                    const formHtml =
                        visitorInfoWidgetTemplate(me.options)
                    const form = me
                        .$("<form id='apexchat_visitorInfo_container_wrapper'></form>", me.context)
                        .append(formHtml);
                    addStyleText(me.options.visitorInfoWidgetCss, 'apexchat_smspop_css');
                    me.$(me.context.body).append(form);
                    me.$(me.elements.phoneWarningSelector, me.context).hide();
                    me.setPlaceHolder();
                    me.bind();
                }
            };
            const bind = function () {
                const me = this;
                const buttonEl = me.$(me.elements.submitBtnSelector, me.context);
                const epButtonEl = me.$('.ep-submit-button', me.context);
                buttonEl.on('click', () => {
                    throttleByFunctionName(function () {
                        me.$(this, me.context).prop('disabled', true);
                        // var name = $('input[name=name]').val();
                        const phone = buttonEl
                            .parents('form')
                            .find(me.elements.phoneSelector)
                            .val();
                        me.formSubmit = true;
                        me.companyLevelBlockValidator = new CompanyLevelBlockValidator(
                            GlobalVariables.CompanyLevelBlockedPages,
                            GlobalVariables.CompanyContextRequest,
                            GlobalVariables.CompanyLevelSettings
                        );

                        if (
                            me.companyLevelBlockValidator &&
                            me.companyLevelBlockValidator.isSMSNumberBlocked(phone)
                        ) {
                            // check if typed number is blocked.
                            return;
                        }
                        if (getCookieValue('livechat_web_sms_number') != phone) {
                            const validator = Object.create(PhoneValidator);
                            validator.phoneCountryData =
                                PhoneCountryData[ApexChat.options.countryCode];
                            validator.phone = phone;
                            const validate = validator.validate();
                            if (validate) {
                                if (epButtonEl.length) {
                                    epButtonEl.text('Sending...').addClass('pointer-event-none');
                                }
                                buttonEl.text('Sending...').addClass('pointer-event-none');
                                const chatId = GetChatID(me.options ?? 0);
                                me.getWebSmsService(
                                    {
                                        initiatedBy: me.options.chatInitiatedBy,
                                        phone,
                                        interceptorResults: me.options.interceptorResult,
                                        chatId,
                                        serviceUrl: chatId
                                            ? '/Handlers/ConvertToSMSHandler.ashx'
                                            : ''
                                    },
                                    (res) => {
                                        me.$(me.elements.formVisitorSelector, me.context).hide();
                                        let msgSent = me.messages.FAILED; // 'Request submission failed.'
                                        if (res.success && res.data) {
                                            msgSent = me.messages.SENT;
                                            Cookies.setShort(
                                                'livechat_web_sms_number',
                                                phone,
                                                me.cookieTime
                                            );
                                        }
                                        me.showMessage(msgSent);
                                        buttonEl.text('Continue').removeClass('pointer-event-none');
                                        if (epButtonEl.length) {
                                            epButtonEl
                                                .text('Continue')
                                                .removeClass('pointer-event-none');
                                        }
                                        // toggle sms bottom sheet
                                        me.$(
                                            '#livechat_bottom_sheet_sms_close',
                                            me.context
                                        ).click();
                                        me.$('.apexchat_rd_transfer_to_sms', me.context).hide();
                                    }
                                );
                            } else {
                                me.showError();
                                if (epButtonEl.length) {
                                    epButtonEl.text('Continue').removeClass('pointer-event-none');
                                }
                                buttonEl.text('Continue').removeClass('pointer-event-none');
                            }
                        } else {
                            me.showWarning();
                        }
                    },
                        7,
                        'transferWebToText'
                    )();
                });

                me.$(me.elements.submitBtnSelector, me.context).prop('disabled', true);
                me.$(me.elements.phoneSelector, me.context).on('keypress', function (event) {
                    const phone = me
                        .$(this, me.context)
                        .val()
                        .replace(/[^+\d].+/, '');
                    me.$(this, me.context).val(phone);
                    if (event.which < 48 || event.which > 57) {
                        return false;
                    }
                });
                me.$(me.elements.cancelBtnSelector, me.context).on('click', () => {
                    me.closeForm();
                });

                me.$(me.elements.phoneSelector, me.context).keyup(() => {
                    if (me.$(me.elements.phoneSelector, me.context).val() != '') {
                        me.enableBtn();
                    } else {
                        me.disableBtn();
                    }

                    if (matchPhone(me.$(me.elements.phoneSelector, me.context).val())) {
                        me.hideWarning();
                        me.hideError();
                    } else if (me.formSubmit) {
                        me.hideWarning();
                        me.showError();
                    }
                });
                me.setPlaceHolder();
            };
            const show = function () {
                const me = this;
                me.$(me.elements.formVisitorSelector, me.context).show();
                me.$(me.elements.formContainerSelector, me.context).show();
            };

            const markDisable = function () {
                const me = this;
                me.$(me.elements.submitBtnSelector, me.context).prop('disabled', true);
            };

            const disableBtn = function () {
                const me = this;
                me.markDisable();
                me.$(me.elements.submitBtnSelector, me.context).removeClass(
                    me.styles.SUBMIT_ENABLED
                );
            };

            const enableBtn = function () {
                const me = this;
                me.$(me.elements.submitBtnSelector, me.context).prop('disabled', false);
                me.$(me.elements.submitBtnSelector, me.context).addClass(me.styles.SUBMIT_ENABLED);
            };
            const showError = function () {
                const me = this;
                me.$(me.elements.phoneWarningSelector, me.context).show();
                me.$(me.elements.phoneSelector, me.context).addClass(me.styles.ERROR_ENABLED);
            };

            const hideError = function () {
                const me = this;
                me.$(me.elements.phoneWarningSelector, me.context).hide();
                me.$(me.elements.phoneSelector, me.context).removeClass(me.styles.ERROR_ENABLED);
            };
            const showWarning = function () {
                const me = this;
                me.$(me.elements.phoneContainerSelector, me.context).addClass(
                    me.styles.WARNING_ENABLED
                );
                me.$(me.elements.submitBtnSelector, me.context).removeClass(
                    me.styles.SUBMIT_ENABLED
                );
                me.$(me.elements.phoneWarningSelector, me.context).show();
            };
            const hideWarning = function () {
                const me = this;
                me.$(me.elements.phoneContainerSelector, me.context).removeClass(
                    me.styles.WARNING_ENABLED
                );
            };
            const showMessage = function (message) {
                const me = this;
                me.$(me.elements.formContainerSelector, me.context).append(
                    `<div id="apexchat_msg_sent">${message}</div>`
                );
                setTimeout(() => {
                    me.closeForm();
                }, 2000);
            };
            const closeForm = function () {
                const me = this;
                if (me.options.hide) {
                    me.options.hide();
                } else {
                    me.$(me.elements.formContainerSelector, me.context).fadeOut('slow');
                }
            };
            const setPlaceHolder = function () {
                const me = this;
                me.$(me.elements.phoneSelector, me.context).attr(
                    'placeholder',
                    me.messages.PLACEHOLDER_PHONE
                );
            };
            const getWebSmsService = function (payload, callback) {
                const me = this;
                if (!window.ga) {
                    googleAnalyticsObjectInit('ga');
                }
                const gaClientId = getGaClientId(me.options.googleAnalyticsAccount, ga);
                const trafficCookie = getCookieValue(
                    'livechat_invitation_traffic_sources'
                );
                const data = {
                    visitationLogID: me.options.visitorId,
                    companyId: me.options.companyId,
                    initiatedBy: payload.initiatedBy,
                    phone: payload.phone,
                    visitorName: payload.name || '',
                    language: me.options.language,
                    chatInterceptorValue: me.interceptorResults,
                    gaClientId,
                    trafficCookie: trafficCookie || ''
                };
                // ajax call to sms log call
                me.$.getJSON(
                    `${GlobalVariables.LiveChatServiceUrl}/Handlers/SmsWebHandler.ashx`,
                    data,
                    (result) => {
                        console.log('sms webhandler requested....');
                        callback(result);
                    }
                );
            };
            return {
                init,
                reset,
                initialDisplay: initialDisplay,
                bind,
                show,
                markDisable,
                disableBtn,
                enableBtn,
                showError,
                hideError,
                showWarning,
                hideWarning,
                showMessage,
                closeForm,
                setPlaceHolder,
                getWebSmsService
            };
        };
        const smsForm = WebSmsFormValidator(me.options);
        smsForm.init();
        this.view = new WidgetView({
            dom: this.DOM,
            identifier: WidgetTypes.WebSmsForm,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    tpl: form,
                    style: [me.options.visitorInfoWidgetCss],
                    model: { name: WidgetTypes.Test },
                    beforeRender(tpl) { },
                    afterRender(tpl) {
                        smsForm.reset();
                        smsForm.bind();
                        me.show();
                    }
                }
            ],
            initialState: WidgetStates.ShownMaximized // specifying initialState automatically render the widget in that state
        });
        addStyleTextInIframe(this.options.invitationWidgetStyle, undefined, undefined, this.DOM);
    }

    show() {
        const me = this;
        super.show();

        this.maximize();
        me.$(`#${me.options.iframeId}`).show();
    }

    maximize() {
        super.maximize();
    }

    hide() {
        super.hide();
    }
}
